import isEmpty from 'lodash/isEmpty';
import { CheckoutState } from '../../state';
import { OrderNamespace } from '../../state/order';
import { getOrder } from './getOrder';

/**
 * Given the orderCosts.feeComponents, we combine all order fee components
 * with the same name to be presented in order summary fee breakdown.
 *
 * @param feeComponents - Order fee components from order service
 * @returns Fee components summed/combined by name and group
 * @was containers/pane/utils.js:getOrderFeeComponents
 */
const _combineOrderFeeComponentsByName = (
    feeComponents: OrderNamespace['costs']['feeComponents'],
) =>
    feeComponents.reduce((acc: typeof feeComponents, element) => {
        // TODO EB-243613 We are mutating the accumulator inside the reducer so this should probably not be a reduce but a regular for loop
        const index = acc.findIndex(
            ({ groupName }) =>
                groupName.toLowerCase().trim() ===
                element.groupName.toLowerCase().trim(),
        );

        let el = element;

        if (el.groupName && el.name !== el.groupName) {
            el.name = el.groupName;
        }

        if (el.payer === 'attendee') {
            if (index !== -1) {
                el = acc[index];
                // This was previosly written as
                // el.value += element.value;
                el.value += element.value;
                acc.splice(index, 1);
            }
            acc.push(el);
        }

        return acc;
    }, []);

/**
 * Gets the cost object from the order if it exists
 * @param {CheckoutState} order An order as returned from order service
 * @was `utils/forms.js:getOrderCosts`
 */
export const getOrderCosts = (
    state: CheckoutState,
    hasFeeBreakdown = false,
) => {
    const order = getOrder(state);
    let costs;

    // TODO EB-243612 We are introducing here side-effects in a selector: costs will be a reference to state.order.costs so updating costs.feeComponents will affect state.order.costs.feeComponents
    if (!isEmpty(order) && 'costs' in order) {
        costs = order.costs;
        if (costs.feeComponents) {
            costs.feeComponents = hasFeeBreakdown
                ? _combineOrderFeeComponentsByName(costs.feeComponents)
                : [];
        }
    }

    return costs;
};
